import { NavLink } from "react-router-dom";
import "./BottomNav.css";

const tabs = [
  { to: "/", icon: "point_of_sale", label: "Sale" },
  { to: "/sales", icon: "receipt_long", label: "Sales" },
  { to: "/inventory", icon: "inventory_2", label: "Stock" },
  { to: "/analytics", icon: "insights", label: "Stats" },
  { to: "/settings", icon: "settings", label: "Config" },
];

export default function BottomNav() {
  return (
    <nav className="bottom-nav">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.to === "/"}
          className={({ isActive }) =>
            `bottom-nav__link${isActive ? " bottom-nav__link--active" : ""}`
          }
        >
          <span className="material-symbols-rounded bottom-nav__icon">{tab.icon}</span>
          <span className="bottom-nav__label">{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
